import http from "./httpService";
import { authApi } from "./config.json";
import auth from "./authService";

export async function updatePassword(
  old_password,
  new_password,
  confirm_password
) {
  const username = auth.getCurrentUser();
  const obj = {
    username,
    old_password,
    new_password,
    confirm_password,
    department: "report",
  };
  const { data } = await http.post(authApi + "updatePassword.php", obj);
  return data;
}



// WEBPACK FOOTER //
// ./src/services/userServices.js